import React from 'react';
import PublicNavbar from '../components/PublicNavbar';
import PublicFooter from '../components/PublicFooter';
import './PrivacyPolicy.css';

export default function PrivacyPolicy() {
  return (
    <div className="privacy-app">
      <PublicNavbar />

      <main className="privacy-page">
        <div className="privacy-container">

          <header className="privacy-header">
            <p className="privacy-eyebrow">Querely — by Inqlect Technologies Pvt Ltd</p>
            <h1 className="privacy-title">Privacy Policy</h1>
            <p className="privacy-meta">Last updated: July 2026</p>
          </header>

          <div className="privacy-body">

            <section className="privacy-section">
              <h2>Who we are</h2>
              <p>
                Querely is an AI-powered SAP assistant operated by Inqlect Technologies
                Pvt Ltd, Bengaluru, Karnataka, India. Accessible at{' '}
                <a href="https://querely.com">querely.com</a>.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Who this policy applies to</h2>
              <p>
                Employees and authorised users of enterprise tenants who access Querely
                through their organisation&rsquo;s account.
              </p>
            </section>

            <section className="privacy-section">
              <h2>What data we collect and why</h2>
              <table className="privacy-table">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Purpose</th>
                    <th>Where stored</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Name, email, role</td>
                    <td>Account creation and authentication</td>
                    <td>Azure PostgreSQL</td>
                  </tr>
                  <tr>
                    <td>Conversation history</td>
                    <td>Multi-turn context</td>
                    <td>Azure PostgreSQL</td>
                  </tr>
                  <tr>
                    <td>Query logs (query text, SAP module, token count, response status)</td>
                    <td>Usage analytics</td>
                    <td>Azure PostgreSQL</td>
                  </tr>
                  <tr>
                    <td>Support tickets</td>
                    <td>Customer support</td>
                    <td>Azure PostgreSQL</td>
                  </tr>
                  <tr>
                    <td>SAP transactional data (orders, invoices, deliveries)</td>
                    <td>Displayed in response to queries</td>
                    <td>Never stored — fetched live and discarded</td>
                  </tr>
                </tbody>
              </table>
            </section>

            <section className="privacy-section">
              <h2>What we do NOT do</h2>
              <ul>
                <li>We do not sell your data.</li>
                <li>We do not use your data to train AI models.</li>
                <li>We do not store SAP transactional data.</li>
                <li>We do not use advertising or tracking cookies.</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>Where your data is stored</h2>
              <p>
                Microsoft Azure, Sweden Central (EU region). Tenant data is isolated
                using Row-Level Security.
              </p>
            </section>

            <section className="privacy-section">
              <h2>AI processing</h2>
              <p>
                Querely uses Azure OpenAI (GPT-4.1-mini) hosted on Microsoft Azure Sweden
                Central. Query text is sent to Azure OpenAI for processing. Azure OpenAI
                does not use this data to train models.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Data retention</h2>
              <p>
                Conversation history and query logs are retained for the duration of your
                active subscription. Data is deleted within 30 days of a written
                termination request. Support tickets are retained for 12 months after
                resolution.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Your rights</h2>
              <p>
                Request access, correction, or deletion of personal data by emailing{' '}
                <a href="mailto:info@inqlect.com">info@inqlect.com</a> or contacting your
                organisation&rsquo;s Querely administrator.
              </p>
            </section>

            <section className="privacy-section">
              <h2>Security</h2>
              <ul>
                <li>HTTPS/TLS encryption in transit</li>
                <li>Azure PostgreSQL encryption at rest</li>
                <li>Row-Level Security tenant isolation</li>
                <li>JWT authentication</li>
              </ul>
            </section>

            <section className="privacy-section">
              <h2>Changes</h2>
              <p>
                Tenant administrators will be notified of material changes via email
                before they take effect.
              </p>
            </section>

            <section className="privacy-section privacy-section--contact">
              <h2>Contact</h2>
              <address>
                Inqlect Technologies Pvt Ltd<br />
                Bengaluru, Karnataka, India<br />
                <a href="mailto:info@inqlect.com">info@inqlect.com</a>
              </address>
            </section>

          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
}
